module.exports = "<p>\r\n  dialog works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialog/dialog.component.html
// module id = ./src/app/components/dialog/dialog.component.html
// module chunks = main